/**
 * Sample Slot Client Mod 定义
 *
 * 演示第三方 Mod 如何注册 slot 到用户中心。
 *
 * 关键点：
 * 1. 只依赖 @hvsin/user-center-contracts（接口包），不依赖 user-center-client-mod
 * 2. 通过 USER_CENTER_SLOTS_INTERFACE_TAG 从 DI 容器获取服务实例
 * 3. 无需声明 modDependencies: ['user-center-client']
 */
import { USER_CENTER_SLOTS_INTERFACE_TAG } from '@hvsin/user-center-contracts';
import { SampleSlotRegistrar } from './sample-slot-registrar.js';
/**
 * sample-slot-client-mod
 *
 * 演示如何注册 slot 到用户中心。
 *
 * 使用方式：
 * ```typescript
 * import { sampleSlotClientMod } from '@hvsin/mod-sample-slot-client'
 *
 * await container.loadMods([userCenterClientMod, sampleSlotClientMod])
 * ```
 */
export const sampleSlotClientMod = {
    name: 'sample-slot-client',
    // 无需声明 modDependencies: ['user-center-client']
    serviceDefs: [
        {
            serviceTag: 'sampleSlotRegistrar',
            serviceImpl: SampleSlotRegistrar,
            // 通过接口标签引用 userCenterSlots 服务
            dependencies: [USER_CENTER_SLOTS_INTERFACE_TAG],
        },
    ],
};
//# sourceMappingURL=mod.js.map